<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="house"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>{{ "WORKFLOW_DIALOGS.REAL_ESTATE_EXECUTION.TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.REAL_ESTATE_EXECUTION.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <form [formGroup]="realEstateForm">
    <payee-form-field
      [width]="'wider'"
      [height]="'taller'"
    >
      <textarea
        payee-input
        formControlName="message"
        [placeholder]="'WORKFLOW_DIALOGS.REAL_ESTATE_EXECUTION.PLACEHOLDER' | translate"
      ></textarea>
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      class="payee-button"
      payee-button
      color="blue"
      width="wide"
      height="normal"
      [disabled]="loading"
      [loading]="loading"
      (click)="submit()"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.REAL_ESTATE_EXECUTION.SUBMIT" | translate }}
      </ng-container>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button"
      payee-button
      mat-dialog-close
      color="white"
      width="wide"
      height="normal"
      [isBorderButton]="true"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.REAL_ESTATE_EXECUTION.CANCEL" | translate }}
      </ng-container>
    </button>
  </ng-template>
</payee-popup>
